// extracted by mini-css-extract-plugin
export default {"listItem":"Es2FN8EcEYXqLxVuHuoR","newFeature":"RTckBd4bGDgITDXT8dTZ"};